export default __webpack_public_path__ + "static/media/Component 2 – 1.e07bb6aa.svg";